import React from "react";
import "./employee.css";
import { useNavigate } from "react-router-dom";
import constants from "../../utils/constants";
import PropTypes from "prop-types";

export default function Employee(props) {
  const nav = useNavigate();

  const isBluewingsCustomer = JSON.parse(localStorage.getItem("isBluewingsCustomer"));
  const selectedEmployee = () => {
    console.log("selectedEmployee::",isBluewingsCustomer,!isBluewingsCustomer);
    if (!isBluewingsCustomer) {
    localStorage.setItem(constants.localStorage.selectedEmployeeId, (props.empId));
    nav(constants.navigationLink.employeeData);
    }
  };

  return (
    <>
      <div className={isBluewingsCustomer ? "emp-main-container p-1 " : "emp-main-container p-1 cursor-emp"} onClick={(() => {
        selectedEmployee();
      })}>
        <div className="d-flex position-relative justify-content-center main-emp-name-photo-container">
          <div className="align-self-center">
            {props.empProfilePic ?
              <img className="img-fluid rounded-circle me-3 emp-photo" src={props.empProfilePic} alt="" /> :
              <div className="default-img me-3">
                <i className="ri-user-2-line"></i>
              </div>
            }

          </div>
          <div className="align-self-center emp-name-name">
            <h6 className="text-white mb-0 emp-name">{props.emp_Name}</h6>
            <p className="emp-designation">{props.empDesignation} {props.empType === "Admin" ? `| ${props.empType}` : ''}</p>
          </div>
        </div>
      </div>

     
    </>
  );
}

Employee.propTypes = {
  empId: PropTypes.number.isRequired,
  empProfilePic: PropTypes.string,
  emp_Name: PropTypes.string.isRequired,
  empDesignation: PropTypes.string.isRequired,
  empType: PropTypes.string
};